import { styled } from '@mui/material/styles';

export const StyledVoiceLibraryContainer = styled('div')`
  .voice-library-card {
    margin: 16px 4px;
    min-height: 101vh;
    .voice-library-banner {
      padding: 0 24px;
    }
  }

  .voice-library-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 1135px;
    width: 100%;
    margin: 0 auto;
  }
`;
